import { render, staticRenderFns } from "./RecentUsers.vue?vue&type=template&id=70c52765&"
import script from "./RecentUsers.vue?vue&type=script&lang=js&"
export * from "./RecentUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports